import {
  DELETE_COACHING_PERFORMANCE,
  GET_ALL_COACHING_PERFORMANCE,
  GET_STUDENT_COACHING_PERFORMANCE,
  GET_COACHING_PERFORMANCE,
  GET_COACHING_PERFORMANCE_BATCH,
} from "../constants/Type";

const initialState = {
  coachingPerformance: null,
  students: null,
  extra: null,
  loading: true,
  results: null,
  all: null,
};

const coachingPerformanceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_COACHING_PERFORMANCE:
      return {
        ...state,
        coachingPerformance: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_ALL_COACHING_PERFORMANCE:
      return {
        ...state,
        all: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_COACHING_PERFORMANCE_BATCH:
      return {
        ...state,
        results: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_STUDENT_COACHING_PERFORMANCE:
      return {
        ...state,
        students: { ...payload.data },
        extra: { ...payload.extra },
        loading: false,
      };
    case DELETE_COACHING_PERFORMANCE:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default coachingPerformanceReducer;
